import React from "react";
import { appointmentDayData } from "../../thirdUtils/constant";
import { IoMdTime } from "react-icons/io";
import { Button, Form, Select, Input, DatePicker, Space } from 'antd';
const { Option } = Select
const AppointmentComponent = (props) => {
    const { selectedLanguage, language } = props
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    const onFinish = async (values) => {
        let formData = new FormData()
        console.log('formData', values)
    }
    const handleChange = (value) => {
        console.log(`Selected: ${value}`);
    };

    const onChange = (date, dateString) => {
        // console.log(date, dateString);
    };
    return (
        <div className="third-design-approach-main third-design-appointment-main">
            <div className="third-design-appointment-container">
                <div className="third-design-appointment-text-div">
                    <h2 className="third-design-heading-1" data-aos="fade-right"
                        data-aos-easing="ease-out-cubic"
                        data-aos-delay="100"
                        data-aos-offset="0"
                        data-aos-duration="1500">{selectedLanguage?.txt_book_now}</h2>
                    <h1 className="third-design-heading-2">{selectedLanguage?.txt_make_an_appointment}</h1>
                    <p className="third-design-heading-text">{selectedLanguage?.txt_it_is_important_to_take_work}
                    </p>
                    <h3 className="opening-hours-text">{selectedLanguage?.txt_opening_hours}</h3>
                    <div className="third-design-appointment-day-div">
                        {
                            appointmentDayData?.map((v, i) => {
                                return (
                                    <div>
                                        <h3>
                                            {isELSelect ? v?.day : (isAlSelect ? v?.alDay : v?.glDay)}
                                        </h3>
                                        <p><span><IoMdTime /></span> {v?.time}</p>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className="third-design-appointment-card-container">
                    <Form
                        labelCol={{ span: 24 }}
                        className='appointment-form'
                        name="basic"
                        onFinish={onFinish}
                    >
                        <div className='third-design-appoint-form-div'>
                            <div>
                                <Form.Item
                                    className="third-design-appointment-div"
                                    name='name'
                                >
                                    <Input className="third-design-appointment-inputs  third-design-appointment-screen-inputs" placeholder={selectedLanguage?.name_label} />
                                </Form.Item>
                            </div>
                            <div>
                                <Form.Item
                                    className="third-design-appointment-div"
                                    name='email'
                                >
                                    <Input className="third-design-appointment-inputs third-design-appointment-screen-inputs" placeholder={selectedLanguage?.input_email_placeholder} />
                                </Form.Item>
                            </div>
                            <div>
                                <Form.Item
                                    className="third-design-appointment-div"
                                    name='service'
                                >
                                    <Select
                                        className="third-design-appointment-inputs third-design-appointment-select third-design-appointment-screen-inputs"
                                        showArrow
                                        showSearch
                                        allowClear
                                        placeholder={selectedLanguage?.service_heading}
                                        optionFilterProp='children'
                                        filterOption={true}
                                        onChange={handleChange}
                                    >
                                        <Option value={'Teeth Whitening'}>{selectedLanguage?.txt_teeth_whitening}</Option>
                                        <Option value={'Teeth Checkup'}>{selectedLanguage?.txt_teeth_checkup}</Option>
                                        <Option value={'Orthodontics'}>{selectedLanguage?.txt_orthodontics}</Option>
                                        <Option value={'Dental Crown'}>{selectedLanguage?.txt_dental_crown}</Option>
                                        <Option value={'Dental Filling'}>{selectedLanguage?.txt_dental_filling_text}</Option>
                                    </Select>
                                </Form.Item>
                            </div>
                            <div>
                                <Form.Item
                                    className="third-design-appointment-div"
                                    name="date"
                                >
                                    <Space direction="vertical" size={12}>
                                        <DatePicker className="third-design-appointment-inputs
                                        third-design-appointment-screen-inputs" placeholder={selectedLanguage?.txt_date} onChange={onChange} needConfirm />
                                    </Space>
                                </Form.Item>
                            </div>
                            <div>
                                <Form.Item
                                    className="third-design-appointment-div"
                                    name='message'
                                >
                                    <Input.TextArea autoSize={{ minRows: 6 }} className="third-design-appointment-inputs third-design-appointment-screen-inputs" placeholder={selectedLanguage?.txt_your_message} />
                                </Form.Item>
                            </div>
                            <div className='third-design-appointment-form-btn-screen-div'>
                                <Form.Item
                                    wrapperCol={{ span: 24, offset: 0 }}
                                >
                                    <Button type="primary" htmlType="submit">
                                        {selectedLanguage?.txt_make_appointment}
                                    </Button>
                                </Form.Item>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    )
}

export default AppointmentComponent